/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:squares-2x2',
    link: '/dashboard'
  },
  {
    id: 'receive',
    title: 'Receção de Mercadorias',
    type: 'basic',
    icon: 'heroicons_outline:truck',
    link: 'arrangement'
  },
  {
    id: 'reposition',
    title: 'Reposição',
    type: 'basic',
    icon: 'heroicons_outline:arrow-path',
    link: 'reposition'
  },
  {
    id: 'picklist',
    title: 'Pickings',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: 'picklists'
  },
  {
    id: 'marketplaces',
    title: 'Importação Encomendas',
    type: 'basic',
    icon: 'mat_outline:local_grocery_store',
    link: 'manual-import'
  },
  {
    id: 'bins',
    title: 'Localizações',
    type: 'basic',
    icon: 'heroicons_outline:map-pin',
    link: 'bins'
  },
  {
    id: 'produtos',
    title: 'Produtos',
    type: 'basic',
    icon: 'heroicons_outline:photo',
    link: 'products'
  },

  {
    id: 'orders',
    title: 'Encomendas',
    type: 'basic',
    icon: 'heroicons_outline:shopping-cart',
    link: 'orders',
    hidden: (item) => true
  },

  {
    id: 'reports',
    title: 'Relatorios',
    type: 'basic',
    icon: 'heroicons_outline:chart-bar',
    link: 'reports',
    hidden: (item) => true
  },

  {
    id: 'picking-transfers',
    title: 'Transf. J',
    type: 'basic',
    icon: 'heroicons_outline:arrows-right-left',
    link: 'picking-transfers'
  },
  {
    id: 'armazens',
    title: 'Armazéns',
    type: 'basic',
    icon: 'heroicons_outline:building-office',
    link: 'warehouses'
  },
  {
    id: 'users',
    title: 'Utilizadores',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: 'users'
  }
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Examplev',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
